import { EventsApi } from "@/api/events";
import { Event } from "@/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { useNotify, useRedirect } from "react-admin";

export const useGetEvent = (id: Event["id"]) => {
  const redirect = useRedirect();
  const notify = useNotify();

  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.EVENT, id],
    queryFn: () => EventsApi.getOne({ eventId: id }),
    enabled: !!id,
  });

  if (isError) {
    notify(error, { type: "error" });
    redirect("list");
  }

  return { event: data!, isEventLoading: isPending };
};
